<div class="input-section">
  <ng-container *ngIf="label">
    <label class="input-label-name font-size-14 fw-600" [for]="inputId">
      {{ label }} <span *ngIf="errorMessage['required']">*</span>
    </label>
  </ng-container>
  <div
    class="custom-dropdown"
    [ngStyle]="{
      minHeight: dropdownHeight,
      border: border,
      maxWidth: dropdownWidth,
    }"
    [ngClass]="{
      'input-has-error': isInvalid,
      'with-placeholder-icon': showPlaceholderIcon && !iconPositionAtEnd,
    }"
  >
    <ng-container *ngIf="showPlaceholderIcon">
      <img
        alt="placeholdericon"
        [ngStyle]="iconPositionAtEnd ? { right: '0px' } : {}"
        [src]="placeholderIcon"
      />
    </ng-container>
    <p-calendar
      inputId="calendar-12h"
      class="calender"
      styleClass="primeng-calender"
      [appendTo]="appendTo"
      [showTime]="showTimeInCalender"
      [hourFormat]="'12'"
      [dateFormat]="'d M yy'"
      [minDate]="effectiveMinDate"
      [maxDate]="effectiveMaxDate"
      [keepInvalid]="true"
      [selectionMode]="selectionMode"
      [placeholder]="placeholder"
      [(ngModel)]="value"
      (ngModelChange)="onInputChange($event)"
    />
  </div>
  <ng-content select=".helper-message" />
  <span *ngIf="isInvalid" class="error-msg">
    {{ getErrorMessage() }}
  </span>
  <ng-content />
</div>
